import { AutocompleteCustomValuesParams } from "PFCore/services/autocomplete/fetch_autocomplete_custom_values";
import { CustomValuesQueryParams } from "PFCore/services/custom_values";

export const customValuesKeys = {
  all: () => ["customValues"],
  list: (params: CustomValuesQueryParams) => [...customValuesKeys.all(), params],
  options: (params: AutocompleteCustomValuesParams) => [...customValuesKeys.all(), params],
  tags: () => [...customValuesKeys.all(), "tags"]
};
